import moment from 'moment-timezone';
import Request from 'files/Request.js';

class NotificationClass {

    id = null;
    unread = false;
    title = null;
    message = null;
    date = null;
    category = null;
    to_user_id = null;
    from_user_id = null;
    for_level = null;
    payload = null;

    constructor() {
        return this;
    }

    create = (props = {}) => {

        this.id = props.id;
        this.unread = props.unread;
        this.title = props.title;
        this.message = props.message;
        this.date = props.date ? moment.utc(props.date).local() : null;
        this.to_user_id = props.to_user_id;
        this.from_user_id = props.from_user_id;
        this.for_level = props.for_level;
        this.category = props.category;
        this.payload = props.payload;
        return this;
    }

    setAsRead = async utils => {
        return new Promise(async (resolve, reject) => {
            try {
                if(!this.unread) {
                    resolve();
                    return;
                }
                await Request.post(utils, '/notifications/', {
                    type: 'set_as_read',
                    id: this.id
                });

                this.unread = false;
                utils.content.update({
                    type: 'notifications',
                    object: this
                });
                resolve();

            } catch(e) {
                reject(e);
            }
        })
    }
}

export default {
    create: props => new NotificationClass().create(props)
};
